// Resource: https://docs.oregonstate.education/api/#/content?id=delete-content-delete

import { mapState, mapGetters, mapActions } from "vuex";

const baseURL = "https://api.oregonstate.education/content/";
const ContentAPI = {
  computed: {
    ...mapState("env", ["publicKey"]),
    ...mapGetters(["getToken", "publicKey", "isDebugMode"]),
    urlEntries() {
      return baseURL + "v1/entries";
    },
    urlEntry() {
      return baseURL + "v1/entry";
    },
    profileConfig() {
      return () => ({
        headers: { Authorization: `Bearer ${this.getToken}` }
      });
    },
    useCache() {
      return !this.isDebugMode;
    },
    id() {
      return "1MrApz84DaBIKFqgBczqQBeIysq68W83vqo0CxbYe8pE";
    }
  },
  methods: {
    ...mapActions([
      "addSurveyQuestion",
      "updateSurveyQuestion",
      "deleteSurveyQuestion",
      "setQuestionData",
      "setRecommendationData"
    ]),
    validate() {
      if (!this.publicKey) {
        console.warn("Attempting call without public_key.");
      }

      if (!this.getToken) {
        console.error("Attempting call without token.");
        return false;
      }

      return true;
    },
    //  Read Content (GET)
    readContentEntries() {
      // This method right now fetches the content for questions and recommendations but is not being used in the application
      if (!this.validate()) {
        return;
      }
      let payloadQuestions = {
        id: this.id,
        page: "Sheet1"
      };
      let payloadRecommendations = {
        id: this.id,
        page: "Sheet2"
      };
      console.log("Attempting Reading Content Entries...");

      //  Fetch for questions
      this.axios
        .get(
          this.urlEntries,
          { params: payloadQuestions },
          this.profileConfig()
        )
        .then((response) => {
          let newValues = response.data.message.map((value, index) => {
            return {
              index: index,
              topic: value.topic,
              questionText: value.question_text,
              questionId: value.questionId,
              uuid: value.question_uuid
            };
          });
          console.log(
            "Reading Content Entries Response",
            response.data.message
          );
          this.setQuestionData(newValues);
        })
        .catch((error) => {
          console.error("Reading Error", error);
        })
        .finally(() => {
          console.log("Completing Reading Content Entries...");
        });

      // Fetch for recommendations this.axios
      this.axios
        .get(
          this.urlEntries,
          { params: payloadRecommendations },
          this.profileConfig()
        )
        .then((response) => {
          let newValues = response.data.message.map((value, index) => {
            return {
              index: index,
              questionUUID: value.question_uuid,
              opportunityForImprovementText:
                value.opportunity_for_improvement_text,
              opportunityForImprovementUrl:
                value.opportunity_for_improvement_url,
              opportunityForImprovementId: value.opportunity_for_improvement_id
            };
          });
          console.log(
            "Reading Content Entries Response",
            response.data.message
          );
          this.setRecommendationData(newValues);
        })
        .catch((error) => {
          console.error("Reading Error", error);
        })
        .finally(() => {
          console.log("Completing Reading Content Entries...");
        });
    },
    //  Create Content (POST)
    createContentEntry(payload, page, callback) {
      if (!this.validate()) {
        return;
      }
      payload.id = this.id;
      payload.page = page;
      payload.payload = JSON.stringify(payload);
      this.axios
        .post(this.urlEntry, payload, this.profileConfig())
        .then((response) => {
          console.log("Create Content Entry Response", response);
          // TODO:
        })
        .catch((error) => {
          console.error("Create Content Entry Error", error);
        })
        .finally(() => {
          console.log("Completing Update Content Entry...");
          // this.readContentEntries();
          if (callback) {
            callback();
          }
        });
    },
    //  Update Content (PUT)
    updateContentEntry(obj, page, callback) {
      if (!this.validate()) {
        return;
      }
      let payload = {
        id: this.id,
        page: page,
        uid_key: "question_uuid",
        uid_value: obj.question_uuid,
        payload: JSON.stringify(obj)
      };
      console.log("Attempting Update Content Entry...", payload);

      this.axios
        .put(this.urlEntry, payload, this.profileConfig())
        .then((response) => {
          console.log("Update Content Entry Response", response.data.message);
          // TODO: Update vuex variable here
        })
        .catch((error) => {
          console.error("Update Error", error);
        })
        .finally(() => {
          console.log("Completing Update Content Entry...");
          if (callback) {
            callback();
          }
        });
    },
    //  Delete Content (DELETE)
    deleteContentEntry(payload, page, callback) {
      if (!this.validate()) {
        return;
      }
      payload.id = this.id;
      payload.page = page;

      this.axios
        .delete(this.urlEntry, { params: payload }, this.profileConfig())
        .then((response) => {
          console.log("Delete Content Entry", response);
          // TODO: save to vuex
        })
        .catch((error) => {
          console.error("Delete Group Error", error);
        })
        .finally(() => {
          console.log("Completing Delete Group...");
          // this.readContentEntries();
          if (callback) {
            callback();
          }
        });
    }
  }
};

export default ContentAPI;
